import './blog-layout.styles';

import initHeader from '@/templates/header-blog/header';
import initFooter from '@/templates/footer-blog/footer';

export default function initBlogLayout() {
   initHeader();
   initFooter();
}